export default __webpack_public_path__ + "static/media/violation.161fe883.svg";